import { memo, useCallback, useEffect, useState } from "react";
import { IFilterItemProps } from "./models";
import {
  AutoCompleteMultiUncontrolled,
  ISelectType,
  useFetch,
} from "@4uhub/lib4uhub";
import { workspacesList } from "../../../../../../../services/ticketWorkspace.service";
import MainApi from "../../../../../../../services/mainApi.service";

const TICKETS_ROUTE = process.env.REACT_APP_TICKETS;

const TICKET_CHANNEL_ROUTE = `${TICKETS_ROUTE}/api/v1/TicketChannels/`;

const TICKET_SERVICES_ROUTE = `${TICKETS_ROUTE}/api/v1/TicketServices/`;

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";

const ticketChannelService = new MainApi(TICKET_CHANNEL_ROUTE);

const ticketServicesService = new MainApi(TICKET_SERVICES_ROUTE);

const genericService = new MainApi(GENERICS_ROUTE);

export const FilterItem = memo(
  ({ value, data, keyValue, onChangeFiltersHandler }: IFilterItemProps) => {
    const { name, code } = data;

    const [options, setOptions] = useState<ISelectType[]>([]);

    let service;

    let GENERIC: string | null = null;

    switch (code) {
      case "1":
        service = ticketServicesService.list;
        break;
      case "2":
        service = workspacesList;
        break;
      case "3":
        service = ticketChannelService.list;
        break;
      case "4":
        GENERIC = "TicketCustomerServiceType";
        service = genericService.list;
        break;
      case "5":
        GENERIC = "TicketType";
        service = genericService.list;
        break;
    }

    const { sendRequest } = useFetch(service);

    const fetchOptionsHandler = useCallback(async () => {
      const { data, success } = await sendRequest(
        GENERIC ? { identifier: GENERIC } : null
      );

      if (data && success) {
        setOptions(data);
      }
    }, []);

    const changeHandler = useCallback(
      (value: ISelectType[] | null) => {
        onChangeFiltersHandler(keyValue, value ?? []);
      },
      [keyValue, name, onChangeFiltersHandler]
    );

    useEffect(() => {
      fetchOptionsHandler();
    }, []);

    return (
      <AutoCompleteMultiUncontrolled
        value={value}
        label={name}
        onValueSelected={changeHandler}
        options={options}
        multiline
        size="small"
      />
    );
  }
);
